import React from "react";
import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";

const Modal = ({ isOpen, onClose, children, width = "5xl" }) => {
  if (!isOpen) return null;

  // Configuration des largeurs disponibles avec des valeurs plus grandes
  const widthClasses = {
    sm: "sm:max-w-sm", // ~384px
    md: "sm:max-w-md", // ~448px
    lg: "sm:max-w-lg", // ~512px
    xl: "sm:max-w-xl", // ~576px
    "2xl": "sm:max-w-2xl", // ~672px
    "3xl": "sm:max-w-3xl", // ~768px
    "4xl": "sm:max-w-4xl", // ~896px
    "5xl": "sm:max-w-5xl", // ~1024px
    "6xl": "sm:max-w-6xl", // ~1152px
    "7xl": "sm:max-w-7xl", // ~1280px
    full: "sm:max-w-full"  // 100%
  };

  // Utiliser une valeur par défaut plus grande
  const selectedWidth = widthClasses[width] || widthClasses["2xl"];

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      {/* Backdrop amélioré avec un effet de flou */}
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-black/40 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 text-center">
          <DialogPanel
            transition
            className={`
              relative
              w-full
              transform
              overflow-hidden
              rounded-xl
              bg-white
              text-left
              shadow-2xl
              transition-all
              ${selectedWidth}
              data-[closed]:translate-y-4
              data-[closed]:opacity-0
              data-[enter]:duration-300
              data-[leave]:duration-200
              data-[enter]:ease-out
              data-[leave]:ease-in
              data-[closed]:sm:translate-y-0
              data-[closed]:sm:scale-95
              mx-auto
            `}
          >
            {/* Contenu principal */}
            <div className="px-6 py-5 sm:p-6">
              {children}
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default Modal;